<template>
  <div class="containerBlock">
    <h3 class="fb titleBorder">产品成本</h3>
    <div class="containerPaddingBlock">
      <a-tabs @change="tabChange" :activeKey="tabSelect" :animated="false">
        <a-tab-pane key="0" tab="配方原料">
          <a-table :scroll="{ x: 0, y }" :columns="rawColumns" :pagination="false" :row-key="record => record.id"
            :rowClassName="rowClassname" :dataSource="raw.formulaRawProductVOList">
            <a-tooltip slot="rawName" slot-scope="text,record"
              style="display: flex; positon: relative;text-align: left">
              <img v-if="record.status === 1" style="width: 26px; position: absolute; top: 0; left: 0"
                src="../../../assets/images/shixiao.svg" />
              <div v-if="record.status === 1" style="width: 22px"></div>
              <template slot="title">{{ overseasFlag == '1' ? (record.aliasName || text) : text }}</template>
              {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
            </a-tooltip>
            <div slot="diffPrice" slot-scope="text,record"
              :class="{ red: record.newestPrice > record.price, green: record.newestPrice < record.price }">
              <a-icon style="font-size:12px" v-if="record.price != record.newestPrice"
                :type="record.newestPrice > record.price ? 'arrow-up' : 'arrow-down'" />
              {{ text || text === 0 ? text.toFixed(3) : text }}
            </div>
            <template
              v-for="col in ['price', 'newestPrice', 'percentage', 'uasge', 'minValue', 'maxValue', 'minLimitValue', 'maxLimitValue']"
              slot-scope="text" :slot="col">
              <span :key="col">{{ text || text === 0 ? text.toFixed(3) : text }}</span>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="1" tab="配方营养需要量">
          <a-table :pagination="false" :dataSource="nut" :row-key="record => $uid()" :scroll="{ x: 0, y }"
            :columns="nutColumns">
            <template v-for="col in ['content', 'minValue', 'maxValue', 'minLimitValue', 'maxLimitValue']" :slot="col"
              slot-scope="text,record">
              {{ text || text === 0 ? text.toFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 0 : 2) : text }}
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import columns from './columns';

export default {
  props: ['rowId'],
  data() {
    return {
      detailLoading: false,
      y: 500,
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      raw: {
        formulaProductPricesInfo: {}
      },
      nut: [],
      detail: {},
      tabSelect: "0",
      ...columns,

      pagination: {},
    };
  },
  mounted() {
    this.getDetail({ id: this.rowId });
    this.rawList({ id: this.rowId });
    this.nutList({ id: this.rowId });
  },
  methods: {
    // 设置分页
    setPager(res) {
      const { total, current, size: pageSize } = res;
      this.pagination = {
        ...this.pagination,
        pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
        pageSize,
        total,
        current,
        showSizeChanger: true,
        showTotal: (total) => <div style="flex:1">共{total}条记录</div>,
      };
    },
    // 减法
    sub(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      return +((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    numberText(val = 0) {
      return val !== null ? +val : 0;
    },
    rowClassname(record) {
      return record.isRawDelete == '1' ? 'selectGary' : '';
    },
    ok() {
      this.$emit('ok');
    },
    cancel() {
      this.$emit('cancel');
    },
    async getDetail(data) {
      this.detailLoading = true;  
      const res = await this.$get('/nhf-app/formulaproduct/detail', data);
      if (res.success) {
        this.detail = res.data;
      }
      this.detailLoading = false;
    },

    tabChange(val) {
      this.tabSelect = val;
    },
    async rawList({ id, ...arg }) {
      const res = await this.$http.get('/nhf-app/formulaproduct/selectFormulaProductRawByProductId', {params: {
        productId: id,
        size: 1000,
        ...arg
      }});
      if (res.success) {
        this.raw = res.data;
      }
    },
    async nutList({ id, ...arg }) {
      const res = await this.$get('/nhf-app/formulaproduct/selectFormulaProductNutritionByProductId', {
        productId: id,
        size: 1000,
        ...arg
      });
      if (res.success) {
        this.nut = res.data;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.cols {
  padding: 15px 20px;
  display: flex;
  align-items: center;

}

.col-item {
  width: 33.333333%;

  &-title {
    font-size: 12px;
    color: #777;
  }
}

.value {
  font-size: 28px;
  font-weight: 700;
  display: flex;
  align-items: center;

  i {
    font-style: normal;
    display: flex;
    align-items: center;
  }

  span {
    margin-left: 5px;
    font-weight: normal;
    font-size: 12px;
  }
}

.green {
  color: green
}

.red {
  color: red
}
</style>
<style lang="scss" scoped>
.priceCols {
  display: flex;
  align-items: center;
}

.fb {
  font-weight: bold;
}

::v-deep .selectGary {
  background-color: rgba(130, 130, 130, 0.1) !important;
}
</style>
